import React from "react";
import { RespFont } from "../Style";
import copy from "../../../assets/common/copy.svg";
import { copyToClipBoard } from "./Functions";

const CopyText = ({
  text,
  dataToCopy,
  width = "max-content",
  marginLeft = "15px",
  alignSelf = null,
  padding = "10px 10px",
  image = true,
}) => {
  let widthS = window.innerWidth; // 1728

  return (
    <div
      style={{ width: width, alignSelf }}
      onClick={(e) => {
        e.stopPropagation();
        copyToClipBoard(dataToCopy);
      }}
    >
      <div
        style={{
          padding,
          borderRadius: "5px",
          border: "1px solid rgba(0, 0, 0, 0.11)",
          cursor: "pointer",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {image && (
          <img
            alt={"copy"}
            src={copy}
            style={{
              width: widthS > 768 ? "20px" : "13px",
              marginLeft,
            }}
          />
        )}
        <RespFont csize={"14px"} psize={"12px"}>
          {text}
        </RespFont>
      </div>
    </div>
  );
};

export default CopyText;
